import React, {Component} from 'react';
import {Link} from 'react-router-dom';

export const COLOR_TRASH = "#888888";
export const COLOR_COMMON = '#000000'; //"#ffffff";
export const COLOR_UNCOMMON = '#00cc00';
export const COLOR_RARE = '#2681fe';
export const COLOR_EPIC = '#b049ff';
export const COLOR_RELIC = '#ff9900';
export const COLOR_TRANSCENDENT = '#cf1313';
export const COLOR_ETERNAL = '#6bd3f7';
export const COLOR_HEIRLOOM = '#ffaaff';
export const COLOR_QUEST_ITEM = '#fff600';

const colorMap = new Map([
    ['Trash', COLOR_TRASH],
    ['Common', COLOR_COMMON],
    ['Uncommon', COLOR_UNCOMMON],
    ['Rare', COLOR_RARE],
    ['Epic', COLOR_EPIC],
    ['Relic', COLOR_RELIC],
    ['Transcendent', COLOR_TRANSCENDENT],
    ['Eternal', COLOR_ETERNAL],
    ['Heirloom', COLOR_HEIRLOOM],
    ['Quest Item', COLOR_QUEST_ITEM],
]);

export default class RarityLink extends Component {
    render() {
        const {rarity, children} = this.props;

        const color = colorMap.has(rarity) ? colorMap.get(rarity) : "#4183c4;";
        return (
            <Link
                {...this.props}
                style={{color: color}}
            >
                {children}
            </Link>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/RarityLink.jsx